const styles = theme => ({
  content: {
    display: 'flex',
    padding: theme.spacing(2),
    justifyContent: 'space-evenly',
    alignItems: 'center',
    flexDirection: 'column',
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
    },
  },
  fullWidth: { width: '100%', margin: '10px' },
})

export default styles
